import { useFlag } from '@calendly/feature-check-react'

import { BOOKING_METHODS } from 'features/one_off_modal'

export const useInviteePermissions = (event, invitee, readonly) => {
  const { id, cancelled, newSchedulable, policy, confirmed, uuid, noShow, blockedByHost } = invitee

  const isGuest = !id && !uuid
  const isGroup = event.eventType.kind === 'group'
  const isCancelled = cancelled && !newSchedulable
  const isRescheduled = cancelled && newSchedulable
  const isConfirmed = !cancelled && confirmed
  const isPoll = event.eventType.bookingMethod === BOOKING_METHODS.poll
  const isEventCancelled = event.cancelled
  const isBookedOnBehalf = !!(invitee.inviteeScheduledBy && (invitee.inviteeScheduledBy.id || invitee.inviteeScheduledBy.name))

  const canMarkNoShow = !readonly && !isGuest && event.started && policy?.noShow && !isCancelled && !isRescheduled
  const canEditEmail = !readonly && !isGuest && !isEventCancelled && policy?.update
  const canReschedule = !readonly && !isGuest && !isEventCancelled && policy?.reschedule && !isPoll
  const canCancel = !readonly && !isGuest && !isEventCancelled && policy?.cancel

  const isReactiveBlockEnabled = useFlag('trust_and_safety_reactive_block')
  const canBlock = isReactiveBlockEnabled
    && !readonly
    && !isGuest
    && !isEventCancelled
    && !isBookedOnBehalf
    && !invitee.blockedByHost
  const canUnblock = isReactiveBlockEnabled
    && !readonly
    && !isGuest
    && !isEventCancelled
    && !isBookedOnBehalf
    && invitee.blockedByHost
    && invitee.blockUuid

  return {
    isGuest,
    isGroup,
    isCancelled,
    isRescheduled,
    isConfirmed,
    isPoll,
    isEventCancelled,
    isBookedOnBehalf,
    canMarkNoShow,
    canEditEmail,
    canReschedule,
    canCancel,
    canBlock,
    canUnblock,
    noShow,
    blockedByHost
  }
}
